import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Confetti from "react-confetti";
// import congratsBannerBg from "../../../../../../../assets/congratsBannerBg.png";
import FutureIdentityCard from "../FutureIdentityCard";

const FutureCompletion = ({ futureData, userName, profileImage, onNext }) => {
  const [showConfetti, setShowConfetti] = useState(true);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
      onNext?.();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onNext]);

  useEffect(() => {
    const handleResize = () =>
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 md:p-8 bg-white overflow-y-auto">
      {/* Background */}
      {/* <img
        src={congratsBannerBg}
        alt="background"
        className="absolute inset-0 w-full h-full object-cover"
      /> */}

      {/* Confetti */}
      {showConfetti && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={250}
          gravity={0.3}
          recycle={false}
          colors={["#FFD700", "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7"]}
        />
      )}

      {/* Main Card */}
      <div className="relative z-10 w-full max-w-6xl mx-auto">
        <div className="text-center mb-4">
          <h1 className="text-2xl md:text-2xl lg:text-[32px] font-gotham font-medium text-[#323232] mb-3">
            {/* Congratulations on hitting the 1st milestone in your journey. */}
            Congratulations! You’re now one step closer to the new you.
          </h1>
          <div className="flex justify-end max-w-4xl mx-auto mt-4">
            <div className="w-20 h-2 bg-[#54B0AF] rounded-full"></div>
          </div>
        </div>

        <div className="w-full max-w-[429px] mx-auto min-h-[712px]">
          <FutureIdentityCard
            futureData={futureData}
            userName={userName}
            profileImage={profileImage}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FutureCompletion;
